<template>
  <div
    class="intro-logo"
  >
    <transition name="fade">
      <img
        v-if="count === 0"
        src="@/assets/images/introLogo01.png"
      >
      <img
        v-else-if="count === 1"
        src="@/assets/images/introLogo02.png"
      >
      <img
        v-else-if="count === 2"
        src="@/assets/images/introLogo03.png"
      >
      <img
        v-else-if="count === 3"
        src="@/assets/images/introLogo04.png"
      >
      <img
        v-else-if="count === 4"
        src="@/assets/images/introLogo05.png"
      >
      <img
        v-else-if="count === 5"
        src="@/assets/images/introLogo06.png"
      >
      <img
        v-else-if="count === 6"
        src="@/assets/images/introLogo07.png"
      >
      <img
        v-else-if="count === 7"
        src="@/assets/images/introLogo08.png"
      >
      <img
        v-else-if="count === 8"
        src="@/assets/images/introLogo09.png"
      >
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Intro',
  components: {
  },
  data () {
    return {
      count: 0,
      delay: 65,
      repeat: 0,
      inter: null
    }
  },
  methods: {
    ...mapActions('common', {
      setIntroAction: 'setIntro'
    }),
    start () {
      this.inter = setInterval(_ => {
        this.count++
        if (this.count === 8) {
          if (this.repeat === 1) {
            clearInterval(this.inter)
            this.setIntroAction('end')
          } else {
            this.count = 0
            this.repeat = 1
          }
        }
      }, this.delay)
    }
  },
  mounted () {
    this.start()
  }
}
</script>
